import React, { useState } from "react";
import useLongPress from "../hooks/useLongPress";
import { Tile } from "./generic/Tile";
import { ConfirmDeleteModal } from "./generic/DeleteConfirmationModal";

export const Favorite = ({
  favorite,
  onClick,
  onDelete,
  isOnList,
  loading,
}) => {
  const longPressHandlers = useLongPress(
    () => {
      setConfirmDeleteOpen(true);
    },
    { delay: 400 }
  );

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);

  return (
    <>
      <Tile
        onClick={onClick}
        key={favorite.id}
        style={{
          backgroundColor: isOnList ? "#e8ffe8" : "#ffb5b9",
        }}
        {...longPressHandlers}
      >
        <span style={{ overflowWrap: "break-word", maxWidth: "100%" }}>
          {favorite.name} {isOnList ? "☑︎" : ""}
        </span>
      </Tile>

      {confirmDeleteOpen ? (
        <ConfirmDeleteModal
          onSubmit={async () => {
            await onDelete(favorite.id);
            setConfirmDeleteOpen(false);
          }}
          onClose={() => setConfirmDeleteOpen(false)}
          loading={loading}
          recordName={`Favorit ${favorite.name}`}
        />
      ) : null}
    </>
  );
};
